import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC, useEffect } from 'react';
import InputControl from '@/components/form/input-control';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { Box } from '@mui/material';
import { ConnectorModel } from '@/lib/models/connector/connector.model';
import { ProxyConnectorModel } from '@/lib/models/connector/proxy-connector.model';
import ProxyDeploymentCard from '../proxy-deployment-card';

interface Props {
  connector: ProxyConnectorModel;
  formHandle: FormHandle<ConnectorModel>;
  mode: ViewMode;
}

const ProxyConnector: FC<Props> = ({ formHandle, mode, connector }) => {
  const inWriteMode = isWriteMode(mode);
  const isNew = !connector.id;

  const { setFieldValue, values } = formHandle;

  // manually update a field value so the form is marked as dirty and can be submitted
  useEffect(() => {
    if (isNew) {
      setFieldValue('config.orgAuthEnabled', true);
    }
  }, [setFieldValue, isNew]);

  if (!inWriteMode) {
    const { pacFileUrl, serviceUrl, catalogUrl } = connector.config;

    return (
      <Box mt={2}>
        <ProxyDeploymentCard
          id={connector.id}
          name={connector.name}
          serviceUrl={serviceUrl ?? pacFileUrl}
          catalogUrl={catalogUrl}
        />
      </Box>
    );
  }

  const { hasConnectorAuthentication } = values as ProxyConnectorModel;

  return (
    <Box>
      <InputControl
        name="config.authenticationType"
        label="Authentication Type"
        formHandle={formHandle}
        type="proxy-auth-type-select"
      />
      {hasConnectorAuthentication && (
        <InputControl
          name="config.emailProxyIdEnabled"
          label="Allow Email Identification in PAC File URL"
          formHandle={formHandle}
          type="switch"
        />
      )}

      <Box mt={2}>
        <InputControl
          name="config.sourceCIDRs"
          label="Source IP Ranges"
          formHandle={formHandle}
          type="proxy-ip-range-list-editor"
        />
      </Box>
    </Box>
  );
};

export default ProxyConnector;
